import { autoinject, bindable } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';
import { Models } from 'models/core';
import { PenOfferDto } from 'models/pen/PenOffers';
import { UserModels } from 'models/UserModels';
import { ContactService } from 'services/contact-service';
import { CustomerService } from 'services/customer-service';
import { DepartmentService } from 'services/department-service';
import { NetStandardService } from 'services/net-standard-service';
import { SiteService } from 'services/site-service';
import { UserService } from 'services/user-service';

@autoinject
export class PenOfferEditForm {
  @bindable private penOffer: PenOfferDto;
  private departments: Array<Models.Department>;
  private sites: Array<Models.Site>;
  private contacts: Array<Models.Contact>;
  private customers: Array<Models.Customer>;
  private userlist: Array<UserModels.User>;

  constructor(
    private departmentService: DepartmentService,
    private userService: UserService,
    private customerService: CustomerService,
    private siteService: SiteService,
    private contactService: ContactService,
    private netStandardService: NetStandardService
  ) {}

  private async attached() {
    const response = await this.customerService.getAll('?$orderby=Name');
    this.customers = response;
    await this.getUsers();

    if (this.penOffer.CustomerId && this.penOffer.CustomerId.toString() !== '') {
      await this.getDepartments(this.penOffer.CustomerId);
      await this.getContacts(this.penOffer.CustomerId);
    }
  }

  private async setCustomer(customerId: number) {
    if (customerId !== this.penOffer.CustomerId) {
      this.departments = [];
      this.sites = [];
      this.contacts = [];
      this.penOffer.CustomerId = customerId;
      await this.getDepartments(this.penOffer.CustomerId);
      await this.getContacts(this.penOffer.CustomerId);
    }
    this.penOffer.CustomerId = customerId;
    await this.getDepartments(this.penOffer.CustomerId);
  }

  @AsyncErrorHandler
  async setDepartment(departmentId: number) {
    if (departmentId !== this.penOffer.DepartmentId) {
      this.penOffer.DepartmentId = departmentId;
      this.sites = [];
      await this.getSites();
    }
  }

  private setResponsibleUser(userId: number) {
    if (!userId || userId.toString() === this.penOffer.ResponsibleUserId?.toString()) {
      return;
    }
    this.penOffer.ResponsibleUserId = userId.toString();
  }

  @AsyncErrorHandler
  async getUsers() {
    const response = await this.userService.getAll();
    this.userlist = response;
  }

  @AsyncErrorHandler
  async getContacts(customerId: number) {
    const response = await this.contactService.getAll('?$filter=CustomerId eq ' + customerId);
    this.contacts = response.filter((x) => x.IsResponsibleForOffers);
  }

  @AsyncErrorHandler
  async getDepartments(customerId: number) {
    if (customerId !== this.penOffer.DepartmentId) {
      const response = await this.departmentService.getAll('?$filter=CustomerId eq ' + customerId);
      this.departments = response;
      this.sites = [];
      await this.getSites();
    }
  }

  @AsyncErrorHandler
  async getSites() {
    let dep: string = '';
    if (this.penOffer.DepartmentId) {
      dep = ' and DepartmentId eq ' + this.penOffer.DepartmentId;
    }
    const response = await this.siteService.getAll('?$filter=CustomerId eq ' + this.penOffer.CustomerId + dep);
    this.sites = response;
  }

  @AsyncErrorHandler
  async getNetStandards() {
    //NetStandard RES 1821 (Chile) is temporary only visible and used in used net so hide here
    //NetStandard NS9415 Faroe Islands is only visible on service so hide here
    //Only show NS 9415-2021, so also hide NS 9415-2009
    return await this.netStandardService.getAll('?$filter=Id ne ' + Models.NetStandardId.RES_1821 + ' and Id ne ' + Models.NetStandardId.NS9415_FaroeIslands + ' and Id ne ' + Models.NetStandardId.NS9415_2009);
  }
}
